<template>
  <go-back :title="'NUEVO AVISO DE PAGO'"></go-back>

  <custom-form @enviar="submit" :disabled="disabled"></custom-form>
</template>

<script>
import { defineComponent, ref } from "vue";
import axios from "axios";
import router from "@/router";
import { apiPostAviso } from "@/router/endpoints";
import {
  formatDataAvisoPago,
  objectToFormData,
  showError,
  showToast,
  checkFormAviso,
} from "@/Functions";
import CustomForm from "@/components/PanelAvisosForm.vue";
import GoBack from "@/components/GoBack.vue";

export default defineComponent({
  components: {
    CustomForm,
    GoBack,
  },
  setup() {
    let disabled = ref(false);

    const submit = (aviso) => {
      aviso = formatDataAvisoPago(aviso);
      let form_data = objectToFormData(aviso);

      disabled.value = true;

      if (checkFormAviso(aviso)) {
        axios
          .post(apiPostAviso(), form_data)
          .then(() => {
            showToast("Aviso creado con éxito", "success");
            router.push({ name: "avisos-de-pago" });
          })
          .catch((err) => {
            showError(err);
          })
          .finally(() => {
            disabled.value = false;
          });
      } else {
        disabled.value = false;
      }
    };

    return { submit, disabled };
  },
});
</script>
